import React from 'react';
import { useTheme } from '@mui/material';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-text';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-tomorrow_night';
import '../styles/TextInputArea.css';

const TextInputArea = ({ label, value, onChange, placeholder, readOnly }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const [copied, setCopied] = React.useState(false);

  // Custom gutter style for Ace
  React.useEffect(() => {
    const gutterBg = isDarkMode ? '#23272e' : '#fff';
    const gutterCss = `.ace_gutter { background: ${gutterBg} !important; }
      .ace_gutter-cell { padding-left: 4px !important; padding-right: 2px !important; }`;
    let styleTag = document.getElementById('ace-gutter-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'ace-gutter-style';
      document.head.appendChild(styleTag);
    }
    styleTag.innerHTML = gutterCss;
    return () => { /* no cleanup needed */ };
  }, [isDarkMode]);

  const handleCopy = () => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <div className={`input-group ${isDarkMode ? 'dark-theme' : ''}`} style={{height: '100%'}}>
      <label className="input-label">{label}</label>
      <div className="input-wrapper" style={{height: '100%'}}>
        <div className="text-area-container" style={{height: '100%', position: 'relative'}}>
          <AceEditor
            mode="text"
            theme={isDarkMode ? 'tomorrow_night' : 'github'}
            value={value}
            onChange={onChange}
            name={label ? label.toString() : undefined}
            width="100%"
            height="100%"
            fontSize={15}
            showPrintMargin={false}
            showGutter={true}
            highlightActiveLine={false}
            readOnly={!!readOnly}
            placeholder={placeholder}
            minLines={14}
            maxLines={20}
            setOptions={{
              showLineNumbers: true,
              tabSize: 2,
              useWorker: false,
              wrap: true,
              displayIndentGuides: false,
              scrollPastEnd: false,
              showInvisibles: false,
              enableBasicAutocompletion: false,
              enableLiveAutocompletion: false,
              enableSnippets: false,
              showFoldWidgets: false,
              showPrintMargin: false,
            }}
            style={{
              borderRadius: 8,
              border: 'none',
              background: isDarkMode ? '#23272e' : '#fff',
              color: isDarkMode ? '#fff' : '#222',
              height: '100%',
              width: '100%',
              fontFamily: 'Fira Mono, Menlo, Monaco, Consolas, monospace',
            }}
          />
          {value && (
            <button
              className="copy-button"
              onClick={handleCopy}
              title="Copy text"
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                zIndex: 10,
                padding: 0,
                margin: 0
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isDarkMode ? '#90caf9' : '#1976d2'} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="8" y="8" width="12" height="12" rx="3"/>
                <rect x="4" y="4" width="12" height="12" rx="3"/>
              </svg>
              {copied && (
                <span style={{
                  position: 'absolute',
                  top: 28,
                  right: 0,
                  background: isDarkMode ? '#1976d2' : '#fff',
                  color: isDarkMode ? '#fff' : '#1976d2',
                  borderRadius: 4,
                  padding: '2px 8px',
                  fontSize: 12,
                  zIndex: 20,
                  boxShadow: isDarkMode ? '0 2px 8px #222' : '0 2px 8px #ccc'
                }}>Copied!</span>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextInputArea; 